import { graphql, type ResultOf } from '@teachino/shared-infrastructure';

export const courseFragment = graphql(`
  fragment Course on Course {
    id
    __typename
    name
    shortName
    foregroundColor
    backgroundColor
    permissions {
      canAddCourseTopicInstance
      canEditCourseTopicInstance
      canRemoveCourseTopicInstance
      canRemoveCourseTopicInstance
    }
  }
`);

type CourseFragment = ResultOf<typeof courseFragment>;

export type Course = Omit<CourseFragment, '__typename'>;

export function convertCourseFragment(course: CourseFragment): Course {
  const { name, id, backgroundColor, shortName, foregroundColor, permissions } =
    course;
  return { id, name, shortName, backgroundColor, foregroundColor, permissions };
}
